import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'

export interface VirusSummaryRes {
  /** 病毒风险终端数 */
  virus_risk_device_count: number
  /** 未处理病毒数 */
  untreated_virus_count: number
  /** 隔离文件数 */
  quarantine_file_count: number
  /** 信任文件数 */
  trusted_file_count: number
}

@Injectable()
export class VirusSummaryCardsService {
  constructor (private http: Http) {}

  @InvokeThrottle()
  getVirusSummary () {
    return this.http.post<VirusSummaryRes>('/safemonitor/virus-scan/summary', {})
  }
}

